import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IProductDataV2 } from '@df/catalog/product/product';
import { DfImageDirective } from '@df/module-image/df-image.directive';
import { PriceComponent } from '@df/ui/price/price.component';
import { CheckboxComponent } from '../../../../../ui/form/checkbox';
import { ProductDecorator } from '../../../../model/product/product.decorator';
import { ProductAbstract } from '../../product.abstract';

@Component({
    selector: 'product-gift-box',
    templateUrl: './product-gift-box.component.html',
    styleUrl: './product-gift-box.component.scss',
    standalone: true,
    imports: [CheckboxComponent, DfImageDirective, FormsModule, PriceComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductGiftBoxComponent extends ProductAbstract implements OnChanges {
    @Input()
    set source(value: ProductDecorator<IProductDataV2>) {
        if (this.modelId !== value.data?.gift_box_product_id) {
            this.modelId = value.data?.gift_box_product_id;
            this.setModelId(this.modelId);
        }
    }

    @Input()
    set giftBoxSelection(value: boolean) {
        if (this._giftBoxSelection !== value) {
            this._giftBoxSelection = value;

            this.giftBoxSelectionChange.emit(value);
        }
    }

    get giftBoxSelection() {
        return this._giftBoxSelection;
    }
    private _giftBoxSelection?: boolean;

    @Output()
    giftBoxSelectionChange = new EventEmitter<boolean>();

    override ngOnChanges(changes: SimpleChanges): void {
        super.ngOnChanges(changes);

        if (changes['giftBoxSelection']) {
            this.detectChanges();
        }
    }

    clickHandle() {
        this.giftBoxSelection = !this.giftBoxSelection;

        this.detectChanges();
    }
}
